import {PreviousMeetingsWidgetStore} from "./previous-meetings-widget-store";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {PreviousMeetingsWidgetConfig} from "./previous-meetings-widget.config";
import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {PreviousMeetingsWidgetHandlers} from "./handlers/previous-meetings-widget.handlers";

export class PreviousMeetingsWidgetController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, PreviousMeetingsWidgetConfig, PreviousMeetingsWidgetStore, PreviousMeetingsWidgetHandlers];
}
